// One place for cache keys, so invalidating never misses a list.

export const queryKeys = {
  me: () => ["me"] as const,
  billing: () => ["billing"] as const,
  tracks: () => ["tracks"] as const,
  track: (trackId: string) => ["tracks", trackId] as const,
  progress: (trackId: string) => ["tracks", trackId, "progress"] as const,
  entries: (trackId: string, filters: Record<string, string> = {}) =>
    ["tracks", trackId, "entries", filters] as const,
  entry: (entryId: string) => ["entries", entryId] as const,
  sites: (trackId: string) => ["tracks", trackId, "sites"] as const,
  relationships: (trackId: string) => ["tracks", trackId, "relationships"] as const,
  invitations: (trackId: string) => ["tracks", trackId, "invitations"] as const,
  invitation: (token: string) => ["invitations", token] as const,
  periods: (trackId: string) => ["tracks", trackId, "periods"] as const,
  period: (periodId: string) => ["periods", periodId] as const,
  reviewQueue: () => ["supervise", "queue"] as const,
  submission: (submissionId: string) => ["submissions", submissionId] as const,
  signedRecords: () => ["supervise", "signed"] as const,
  signedRecord: (recordId: string) => ["records", recordId] as const,
  exports: (trackId: string) => ["tracks", trackId, "exports"] as const,
  import: (importId: string) => ["imports", importId] as const,
  importRows: (importId: string, status = "all") => ["imports", importId, "rows", status] as const,
};
